import type { CheckoutAttribution } from "../api/generated/model";
import { checkoutAttribution } from "../platform/onboarding-tracking";

/** Adapt the consent-filtered browser values to the HTTP DTO's explicit nullable fields. */
export function firstAdCheckoutAttribution(): CheckoutAttribution {
  const saved = checkoutAttribution();
  return {
    utm_source: saved.utm_source ?? null, utm_medium: saved.utm_medium ?? null,
    utm_campaign: saved.utm_campaign ?? null, utm_content: saved.utm_content ?? null,
    utm_term: saved.utm_term ?? null, fbclid: saved.fbclid ?? null,
    fbp: saved.fbp ?? null, fbc: saved.fbc ?? null,
  };
}
